import { iFirestoreAuthService, FirestoreAuthUser } from './firestore.types';

export default class FirestoreAuthService implements iFirestoreAuthService {
  private firestoreAuth: firebase.auth.Auth;

  constructor(firestoreAuth: firebase.auth.Auth) {
    this.firestoreAuth = firestoreAuth;
  }

  async createUser(email: string, password: string): Promise<FirestoreAuthUser | null> {
    const data = await this.firestoreAuth
      .createUserWithEmailAndPassword(email, password);

    if (!data || !data.user) return null;

    return data.user as FirestoreAuthUser;
  }

  isAuthenticated(): Promise<boolean> {
    return new Promise<boolean>((resolve, reject) => {
      const unsubscribe = this.firestoreAuth.onAuthStateChanged((user) => {
        unsubscribe();
        resolve(!!user && user.emailVerified);
      }, reject);
    });
  }

  signOut(): Promise<void> {
    return this.firestoreAuth.signOut();
  }

  async signIn(email: string, password: string): Promise<FirestoreAuthUser | null> {
    await this.firestoreAuth
      .signInWithEmailAndPassword(email, password);

    const { currentUser } = this.firestoreAuth;

    if (!currentUser) return null;

    return currentUser as FirestoreAuthUser;
  }
}
